import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so we don't re-fetch on every component mount.
let _stockMap = null;
let _fetching = null;

const fetchStock = () => {
  if (_stockMap) return Promise.resolve(_stockMap);
  if (_fetching) return _fetching;
  _fetching = fetch(`${API}/stock-status`)
    .then((r) => r.json())
    .then((d) => {
      _stockMap = d.stock || {};
      return _stockMap;
    })
    .catch(() => ({}))
    .finally(() => {
      _fetching = null;
    });
  return _fetching;
};

/**
 * useStockStatus(slug)
 * Returns 'instock' | 'outofstock' | 'onbackorder' | null (loading).
 * The map is fetched once per page load and cached in memory.
 */
export const useStockStatus = (slug) => {
  const [status, setStatus] = useState(_stockMap ? _stockMap[slug] || 'outofstock' : null);
  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    fetchStock().then((map) => {
      if (!cancelled) setStatus(map[slug] || 'outofstock');
    });
    return () => {
      cancelled = true;
    };
  }, [slug]);
  return status;
};

export const useStockMap = () => {
  const [map, setMap] = useState(_stockMap || {});
  useEffect(() => {
    let cancelled = false;
    fetchStock().then((m) => {
      if (!cancelled) setMap(m);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return map;
};
